<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtSearch } from 'jtech-webcomps'
import PersonSearchModal from './PersonSearchModal.vue'

@Component({
  mixins: [JtSearch],
  name: 'personSearch',
  components: {}
})
class PersonSearch extends Vue {
  get config () {
    return {
      formInterface: this.input.nmInterface,
      buscaInterface: this.input.nmInterface,
      dataTableInterface: this.input.nmInterface,
      codeField: this.input.nmAtributoChaveSelecao,
      buscaField: this.input.nmAtributoCodigoSelecao,
      textField: this.input.elDescricaoSelecao,
      nmInterfaceGravarSelecao: this.input.nmInterfaceGravarSelecao
    }
  }

  dataHandler ({ textField, codeField, idField }) {
    this.searchField = codeField
    this.searchFieldMemory = codeField
    this.searchResult = textField
    if (idField) this.__set(idField)
    this.$emit('found', { textField, codeField, idField })
    this.$emit('search-found', { textField, codeField, idField })
  }

  get type () {
    return this.typeAtributoCodigoSelecao || 'text'
  }

  get _modal () {
    return PersonSearchModal
  }
}
export default PersonSearch
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
